<script>
import Result from "./Result"

export default {
  extends: Result,
  data() {
    return {
    };
  },
  computed: {
    
  },
  beforeDestroy() {
  }
};
</script>
<style lang="scss" scoped>
.result {
  position: relative;
  height: 100vh;
  font-weight: 500;
  background: white;
  .green {
    color: #1dc05e !important;
  }
  .red {
    color: red !important;
  }

  .result-content {
    width: 100%;
    position: absolute;
    text-align: center;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    h2 {
      color: #1a1a1a;
      margin: 10px 0;
    }

    .total_score {
      span {
        color: #7a8189;
      }
      span.green {
        font-size: 24px;
      }
    }
    .result-message {
      font-size: 13px;
      color: #bcbcbc;
    }
  }
}
</style>
